module.exports = require('./helpers/bundle-url').getBundleURL('f1MDn') + "logo.c51670a8.svg";